import React from 'react'
import reduce from 'lodash/reduce'
import Typography from '@material-ui/core/Typography'

import 'react-quill/dist/quill.core.css'

import './RichText.css'

const EMPTY_PARAGRAPHS = []
const RichText = ({ children }) => {
  const html = reduce(
    EMPTY_PARAGRAPHS,
    (string, empty) => string.replace(new RegExp(empty, 'gi'), ''),
    children,
  )

  return (
    <Typography
      component="div"
      variant="subtitle1"
      color="textSecondary"
      className="richText ql-editor"
      dangerouslySetInnerHTML={{ __html: html }}
    />
  )
}

export default RichText
